import React from 'react';
import PropTypes from 'prop-types';
import { Prompt } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import ViewList from '@mui/icons-material/ViewList';
import { isValid } from '@totalsoft/pure-validations-react';
import DocumentTypePropertyGeneralDataComponent from './DocumentTypePropertyGeneralDataComponent';
import { Card, IconButton } from '@totalsoft/rocket-ui';

export const DocumentTypePropertyGeneralDataCard = ({
  documentTypeXProperty,
  properties,
  propertyTypes,
  propertyDetails,
  onSave,
  onPropertyChanged,
  validation
}) => {
  const [t] = useTranslation();

  return (
    <Card
      icon={ViewList}
      iconColor='primary'
      title={t('DocumentTypes.DocumentTypeProperty.EditDocumentTypeProperty.GeneralData')}
      actions={
        <IconButton
          type='save'
          fontSize='medium'
          color='transparent'
          tooltip={t('DocumentTypes.DocumentTypeProperty.EditDocumentTypeProperty.SaveChanges')}
          onClick={onSave}
          disabled={!documentTypeXProperty.changed || !(validation |> isValid) || documentTypeXProperty.saving}
        />
      }
    >
      <>
        <Prompt
          when={documentTypeXProperty.changed && !documentTypeXProperty.saving}
          message={t('DocumentTypes.DocumentTypeProperty.EditDocumentTypeProperty.LeavingWithoutSavingDocumentTypeProperty')}
        />
        <DocumentTypePropertyGeneralDataComponent
          documentTypeXProperty={documentTypeXProperty}
          onPropertyChanged={onPropertyChanged}
          properties={properties}
          propertyTypes={propertyTypes}
          propertyDetails={propertyDetails}
          validation={validation}
        />
      </>
    </Card>
  );
};

DocumentTypePropertyGeneralDataCard.propTypes = {
  documentTypeXProperty: PropTypes.object.isRequired,
  properties: PropTypes.array.isRequired,
  propertyTypes: PropTypes.array.isRequired,
  propertyDetails: PropTypes.array.isRequired,
  onSave: PropTypes.func.isRequired,
  onPropertyChanged: PropTypes.func.isRequired,
  validation: PropTypes.object.isRequired
};

export default DocumentTypePropertyGeneralDataCard;
